import React, { useState }  from 'react'
import moment from "moment";
import Select from "react-select";
import * as Yup from "yup";
import { Field, Formik } from "formik";
import {
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  InputGroup,
  InputGroupText,
} from "reactstrap";

import ErrorBoundary from "components/ErrorBoundary";
import FormikDatePicker from "components/common/Fields/FormikDatePicker";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import FormikInputField from "components/common/Fields/FormikInputField";
import Calendar from "assets/icon/calendar-icon.svg";
import{pharmcyOptions,coveredEntityOptions,thirdPartyOptions} from "pages/commonData";

const validationSchema = Yup.object({
  thirdparty: Yup.string().required("Third Party Administrator is required"),
});
const entity = [];
const coveredEnitity = "";
const initialValues = {
  thirdparty: "",
  entityname: "",
  pharmacyname: "",
};

const thirdPartyOption = [...thirdPartyOptions];
const coveredEntityName = [...coveredEntityOptions];
const pharmcyNameOption = [...pharmcyOptions];

const SearchPayor = ({ onSearch, onReset }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleReset = ({ resetForm }) => {
    resetForm();

    onReset();
    // updateStates(merge(claimsManager, claimsInitialValues));
  };

  const handleSubmit = async (val, actions) => {
    console.log({ val });
    onSearch();
  };

  return (
      <Formik
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={initialValues}
        children={(props) => {
          const {
            isSubmitting,
            handleSubmit,
            resetForm,
            setFieldValue,
            errors,
            touched,
          } = props;
          return (
            <div>
              <h5 className="f-15 text-primary font-weight-700">
                Payor
              </h5>
              <Row>
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="thirdparty">Third Party Administrator</Label>
                    <Field
                      name="thirdparty"
                      type="text"
                      className="required"
                      component={FormikSelectField}
                      options={thirdPartyOption}
                      defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="entityname">Covered Entity</Label>
                    <Field
                      name="entityname"
                      type="text"
                      component={FormikSelectField}
                      options={coveredEntityName}
                      defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label for="pharmacyname">Pharmacy</Label>
                    <Field
                      name="pharmacyname"
                      type="text"
                      component={FormikSelectField}
                      options={pharmcyNameOption}
                      defaultoption="--Select--"
                      keys={{
                        id: "id",
                        label: "label",
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="ms-3"
                  >
                    Search
                  </Button>
                  <Button color="primary" onClick={() => handleReset(props)}>
                    Reset
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    );
}

export default SearchPayor